import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue"
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectLevel',
  props: {
    modelValue: {},
    items: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, _mergeProps({
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    items: props.items,
    label: _unref(i18n).global.t('pages.departments.createOrUpdateModal.level'),
    "item-title": "label",
    "item-value": "key",
    outlined: "",
    dense: "",
    class: "w-100"
  }, {'return-object': true}, {
    clearable: false,
    "error-messages": props.errorMessages
  }), null, 16, ["modelValue", "items", "label", "error-messages"]))
}
}

})